/** Severity of the log message
 */
export enum LogMessageSeverity {
  none = 0,
  critical = 1,
  error = 2,
  warning = 4,
  information = 8,
  verbose = 16,
}
